//#region src/apiUrls.ts
var e = "https://lightspeed.ecommerce.api.myparcel.nl", t = "https://lightspeed.ecommerce.api.acceptance.myparcel.nl";
//#endregion
export { e as n, t };
